import { onUnmounted } from "vue";
import { centrifugeManager } from "./centrifugeManager";

/**
 * Vue composable для подписки на Centrifuge канал.
 * Автоматически отписывается при unmount компонента.
 *
 * @param {string} channel
 * @param {(data: any, ctx: object) => void} cb
 * @returns {{ unsubscribe: () => void }}
 */
export function useCentrifuge(channel, cb) {
  const unsubscribe = centrifugeManager.subscribe(channel, cb);

  onUnmounted(() => {
    unsubscribe();
  });

  return { unsubscribe };
}
